var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useRef, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { useParams } from "react-router";
import Api2 from "../../utils/api2";
// import html2canvas from 'html2canvas'
// import {saveAs} from 'file-saver'
// import moment from 'moment'
import Loading2 from "../main/loading2";
var Shoot = function () {
    var _a = useParams(), item_id = _a.item_id, idx_b_manager = _a.idx_b_manager;
    var _b = useState([]), itemSpec = _b[0], setItemSpec = _b[1];
    var view = useRef(null);
    // const date = new Date()
    // const imgSave = () => {
    //     html2canvas(view.current, { useCORS: true }).then((canvas) => {
    //         canvas.toDataURL("image/jpeg", 1.0)
    //         canvas.toBlob(function (blob) {
    //             blob && saveAs(blob, `상품 상세 스펙_${moment(date).format('YYMMDD_HHmmss')}.jpg`)
    //         }, "image/jpeg", 1.0); // JPG 파일로 저장
    //     })
    //     /**
    //      * 이미지 저장 후 처리
    //      * */
    //     //     .then(()=> {
    //     //     // setTimeout(() => {
    //     //     //     // props.onCaptureHandler()//상세스펙 창 닫힘
    //     //     // }, 2000)
    //     // })
    // }
    useEffect(function () {
        /**
         * 테스트 상품: https://shopping.pping.loc:3000/detail/spec/12912508/9082
         * */
        Api2.getCatalogSpec(item_id, idx_b_manager).then(function (res) {
            if (res) {
                setItemSpec(res.data.items);
                // setTimeout(() => {
                //     imgSave() //->백에서 캡쳐
                // }, 100)
            }
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyle, null),
        itemSpec.length === 0
            ? React.createElement(Loading2, null)
            : React.createElement(Wrap, null,
                React.createElement("div", { className: 'container', ref: view },
                    React.createElement("div", null,
                        React.createElement("span", null, "\uC0C1\uD488 \uC0C1\uC138 \uC2A4\uD399")),
                    React.createElement("table", null,
                        React.createElement("tbody", null, itemSpec.map(function (v, i) {
                            return (React.createElement("tr", { key: i },
                                React.createElement("td", null, (v === null || v === void 0 ? void 0 : v.categoryName) || '-'),
                                React.createElement("td", null, (v === null || v === void 0 ? void 0 : v.itemFullName) || '-')));
                        })))))));
};
export default Shoot;
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    #header, #footer {\n        display: none;\n    }\n"], ["\n    #header, #footer {\n        display: none;\n    }\n"])));
var Wrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position:absolute;\n    z-index:9999;\n    width:100%;\n    height:calc(100vh - 20px);\n    overflow:hidden;\n    background:#ffffff;\n    font-size:35px;\n    font-weight:bold;\n    font-family:'Noto Sans KR', sans-serif;\n    color:#333;\n    .container{\n        width:700px;\n        margin:0 auto;\n        &>div{\n            width:100%;\n            text-align:center;\n            background:#EFEFEF;\n            border-bottom:2px solid #1063A7;\n            &>span{\n                padding:10px;\n                display:inline-block;\n                line-height:51px;\n            }\n        }\n    }\n    table{\n        width:100%;\n        margin-top:28px;\n        border:1px solid #E3E3E3;\n        font-size:18px;\n    }\n    tr{ border-bottom:1px solid #E3E3E3; }\n    td{\n        border:1px solid #E3E3E3;\n        word-wrap:break-word; /* \uAE34 \uB0B4\uC6A9\uC77C \uB54C \uC904 \uBC14\uAFC8 */\n        padding:11px 0;\n        &:first-child{\n            width:142px;\n            background:#F7F7FA;\n            text-align:center;\n        }\n        &:last-child{\n            width:calc(100% - 142px);\n            padding-left:21px;\n            padding-right:21px;\n        }\n    }\n"], ["\n    position:absolute;\n    z-index:9999;\n    width:100%;\n    height:calc(100vh - 20px);\n    overflow:hidden;\n    background:#ffffff;\n    font-size:35px;\n    font-weight:bold;\n    font-family:'Noto Sans KR', sans-serif;\n    color:#333;\n    .container{\n        width:700px;\n        margin:0 auto;\n        &>div{\n            width:100%;\n            text-align:center;\n            background:#EFEFEF;\n            border-bottom:2px solid #1063A7;\n            &>span{\n                padding:10px;\n                display:inline-block;\n                line-height:51px;\n            }\n        }\n    }\n    table{\n        width:100%;\n        margin-top:28px;\n        border:1px solid #E3E3E3;\n        font-size:18px;\n    }\n    tr{ border-bottom:1px solid #E3E3E3; }\n    td{\n        border:1px solid #E3E3E3;\n        word-wrap:break-word; /* \uAE34 \uB0B4\uC6A9\uC77C \uB54C \uC904 \uBC14\uAFC8 */\n        padding:11px 0;\n        &:first-child{\n            width:142px;\n            background:#F7F7FA;\n            text-align:center;\n        }\n        &:last-child{\n            width:calc(100% - 142px);\n            padding-left:21px;\n            padding-right:21px;\n        }\n    }\n"])));
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/catalog/shoot.tsx
// module id = 318
// module chunks = 0